var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"CustomSMSButton d-flex align-items-center justify-content-center pointer",on:{"click":function($event){return _vm.toggleModal('CustomDirectDebitModal')}}},[_c('i',{staticClass:"fas fa-wallet"})])
}
var staticRenderFns = []

export { render, staticRenderFns }